var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4688 18.7618V18.5034C13.4688 18.251 13.4914 18.0033 13.535 17.7618C13.7063 16.8125 14.2006 15.9576 14.9122 15.2786C15.9624 14.2766 17.4896 13.6523 19.181 13.6523C20.0408 13.6523 20.8576 13.8136 21.5907 14.1034C23.2727 14.7683 24.5318 16.1212 24.8271 17.7618C24.8706 18.0032 24.8932 18.2508 24.8932 18.5034V18.7618H13.4688ZM23.8045 17.7618C23.5223 16.5926 22.5825 15.5708 21.2231 15.0334C20.6079 14.7902 19.9159 14.6523 19.181 14.6523C17.7313 14.6523 16.4559 15.188 15.6025 16.0021C15.0752 16.5052 14.7134 17.1085 14.5566 17.7618H23.8045Z",
    fill: "#B2AFC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 12C20.1043 12 20.9998 11.1046 20.9998 10C20.9998 8.89543 20.1043 8 18.9998 8C17.8952 8 16.9998 8.89543 16.9998 10C16.9998 11.1046 17.8952 12 18.9998 12ZM18.9998 13C20.6566 13 21.9998 11.6569 21.9998 10C21.9998 8.34315 20.6566 7 18.9998 7C17.3429 7 15.9998 8.34315 15.9998 10C15.9998 11.6569 17.3429 13 18.9998 13Z",
    fill: "#B2AFC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0907 17.7675L30.0617 20.7385L33.2629 17.6952L34.6514 19.0837L31.4502 22.1269L34.4361 25.1129L33.0729 26.4088L30.0869 23.4229L26.901 26.4516L25.5125 25.0631L28.6985 22.0344L25.7275 19.0634L27.0907 17.7675Z",
    fill: "#E26982"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40234 7.49054C4.40234 7.17432 4.65869 6.91797 4.97492 6.91797H10.4688C10.785 6.91797 11.0413 7.17432 11.0413 7.49054C11.0413 7.80677 10.785 8.06312 10.4688 8.06312H4.97492C4.65869 8.06312 4.40234 7.80677 4.40234 7.49054Z",
    fill: "#B2AFC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40234 10.8109C4.40234 10.4946 4.65869 10.2383 4.97492 10.2383H7.14927C7.4655 10.2383 7.72185 10.4946 7.72185 10.8109C7.72185 11.1271 7.4655 11.3834 7.14927 11.3834H4.97492C4.65869 11.3834 4.40234 11.1271 4.40234 10.8109Z",
    fill: "#B2AFC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14515 21.2823V4.71772C2.14515 4.4015 2.4015 4.14515 2.71772 4.14515H27.498C27.8143 4.14515 28.0706 4.4015 28.0706 4.71772V16.0264H29.2158V4.71772C29.2158 3.76905 28.4467 3 27.498 3H2.71772C1.76905 3 1 3.76905 1 4.71772V21.2823C1 22.231 1.76905 23 2.71772 23H23.7387V21.8549H2.71772C2.4015 21.8549 2.14515 21.5985 2.14515 21.2823Z",
    fill: "#B2AFC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapFailed);
export default __webpack_public_path__ + "static/media/snap-failed.1bf4e15d.svg";
export { ForwardRef as ReactComponent };